import NiceModal from "@ebay/nice-modal-react";
import {AccountSwitcherDetails} from "@bounce/shared/consumer/declarations";
import {generatePath, useNavigate} from "react-router-dom";
import {useGetUserQuery} from "~/api/requests";
import AccountDetailsDialog from "~/pages/account/account/components/AccountDetailsDialog";
import {urls} from "~/routes/consumerUrls";
import React from "react";

export const useBundleAccountClick = (partnerCode?: string) => {
  const navigate = useNavigate();
  const {data: user} = useGetUserQuery({});
  const switcher = user?.accounts_switcher as AccountSwitcherDetails[] | undefined;
  const bundleAccount = switcher
    ?.filter((a) => !partnerCode || a.partner_code === partnerCode)
    .find((a) => a.bundle_details?.bundle_primary_account);
  const bundleHasActivePlan = !!bundleAccount?.active_payment_plan;

  return async (accountId: string, e?: React.MouseEvent) => {
    e?.stopPropagation();
    await NiceModal.show(AccountDetailsDialog, {
      accountId,
      isBundle: true,
      hideActions: bundleHasActivePlan,
      onResolve: bundleHasActivePlan
        ? undefined
        : (e: React.MouseEvent) => {
            e.preventDefault();
            NiceModal.hide(AccountDetailsDialog);
            navigate(`${generatePath(urls.accountMain.url, {accountId})}?singleAccount=true`);
          },
    });
  };
};
